import { Injectable } from '@angular/core';
import { Settings } from '../../../core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { EQueriesSummariesReadModel, EQuerySummary } from '../models/e-query-summary';
import { FilterFieldValue } from '../../../covance-filter';
import { map, switchMap, startWith } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { EQuerySummaryFilterItem, EQuerySummaryFilterItemsReadModel } from '../models/e-query-summary-filter-item';
import { prepareFilterUrlParams } from '../../../documents/prepare-filter-url-params';
import { FilterUrlParamsPreparer } from './filter-url-params-preparer';

@Injectable()
export class EQuerySummaryStorage {
    private readonly refresher = new BehaviorSubject<boolean>(true);
    constructor(
        protected readonly settings: Settings,
        protected readonly http: HttpClient,
        private readonly filterUrlParamsPreparer: FilterUrlParamsPreparer
    ) {
    }

    public forceLoadEQueries() {
        this.refresher.next(true);
    }

    public getEQuerySummaries(filterFields: FilterFieldValue[]): Observable<EQuerySummary[]> {
        const filtersParams = this.filterUrlParamsPreparer.prepareFilterUrlParams(filterFields);
        return this.refresher.pipe(
            switchMap(() => this.http.get(`${this.settings.apiUrl}/coordinator/e-queries`, {params: filtersParams})
                .pipe(
                    map((response) => deserialize(response, EQueriesSummariesReadModel).eQueries)
                )
            ),
            startWith(null),
        );
    }

    public getEQueryFilterItems(fields$: Observable<FilterFieldValue[]>): Observable<EQuerySummaryFilterItem[]> {
        return fields$.pipe(switchMap((fields) => {
            const params = prepareFilterUrlParams(fields);
            return this.http.get(
                `${this.settings.apiUrl}/coordinator/e-query-filter-items`, {params: params}
            ).pipe(
                map((r) => deserialize(r, EQuerySummaryFilterItemsReadModel).eQueriesFiltersItems)
            );
        }));
    }
}
